export * from './ProductDetailsIngredientsViewSM';
export * from './ProductDetailsIngredientsViewXS';
